<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="() => openPowerPlantForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="plants"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">
          {{ props.item.status | FormatPowerPlantStatus }}
        </td>
        <td
          class="text-xs-center"
          :style="{
            color: props.item.contract_due_date <= 45 ? 'red' : 'black',
          }"
        >
          {{
            formatDueDate(props.item.contract_due_date, props.item.contract_end)
          }}
        </td>
        <td class="text-xs-center">{{ props.item.installation_number }}</td>
        <td class="text-xs-center">{{ props.item.power_monthly }}</td>
        <td class="text-xs-center">{{ props.item.code_legal_one }}</td>
        <td class="text-xs-center">
          <v-btn
            v-if="props.item.contract || props.item.hasContract"
            color="grey darken-1"
            dark
            flat
            icon
            @click="openPowerPlantContractsList(props.item.id)"
          >
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="() => openPowerPlantForm('edit', props.item.id)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-tooltip bottom v-if="props.item.status !== 'canceled'">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="error"
                >
                  delete
                </v-icon>
              </v-btn>
            </template>
            <span>Cancelar Usina</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="success"
                >
                  restore_from_trash
                </v-icon>
              </v-btn>
            </template>
            <span>Reativar Usina</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_modify_status_powerPlant" max-width="290" dark>
      <v-card color="#7C3DFF">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ newPowerPlantStatus !== "canceled" ? "ativar" : "cancelar" }} esse
          parceiro?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red"
            @click="() => (dialog_modify_status_powerPlant = false)"
            dark
          >
            Não
          </v-btn>
          <v-btn color="green" dark @click="() => cancelOrActivate()">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <power-plant-form
      :key="powerPlantFormData.key"
      :type="powerPlantFormData.type"
      :powerPlantId="powerPlantFormData.powerPlantId"
    />

    <power-plant-contracts-list
      :key="powerPlantContractData.key"
      :powerPlantId="powerPlantContractData.powerPlantId"
    />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { updatePlantsFb } from "@/services/powerplants";
import PowerPlantForm from "./PowerPlantForm.vue";
import PowerPlantContractsList from "./PowerPlantContractsList.vue";
import moment from "moment";

export default {
  components: {
    PowerPlantForm,
    PowerPlantContractsList,
  },

  data: () => ({
    search: "",
    dialog_modify_status_powerPlant: false,
    newPowerPlantStatus: null,
    powerPlantFormData: {
      key: 0,
      type: null,
      powerPlantId: null,
    },
    powerPlantContractData: {
      key: "A" + 0,
      powerPlantId: null,
    },
    headers: [
      { text: "ID", align: "center", value: "id" },
      { text: "Status", align: "center", value: "status" },
      {
        text: "Vencimento do Contrato",
        align: "center",
        value: "contract_due_date",
      },
      {
        text: "Número da Instalação",
        align: "center",
        value: "installation_number",
      },
      {
        text: "Performance Alvo (kWh)",
        align: "center",
        value: "power_monthly",
      },
      { text: "Código Legal One", align: "center", value: "code_legal_one" },
      { text: "Contratos", align: "center", value: "contract" },
      { text: "Ações", align: "center", value: "actions" },
    ],
    pag: { rowsPerPage: 50 },
  }),

  computed: {
    ...mapState("configuration", ["loading", "plants"]),
    formatDueDate() {
      return (contract_due_date, contract_end) => {
        // foi definido 999999 na função getPlants() para os contratos que não tem data de vencimento ficarem no final da lista
        if (!contract_end && contract_due_date == 999999) {
          return "";
        }
        const date = moment(contract_end?.toDate()).format("DD/MM/YYYY");
        if (contract_due_date <= 0) {
          return `${date} (vencido)`;
        }
        if (contract_due_date <= 90) {
          return `${date} (${contract_due_date} dias restantes)`;
        }
        return date;
      };
    },
  },

  methods: {
    ...mapMutations("configuration", [
      "setPowerPlantDialog",
      "setPowerPlantContractsList",
    ]),
    ...mapActions("configuration", ["getPlants"]),

    startUpdate(id, status) {
      if (status === "canceled") status = "activated";
      else status = "canceled";

      this.newPowerPlantStatus = status;
      this.powerPlantFormData.powerPlantId = id;
      this.dialog_modify_status_powerPlant = true;
    },

    cancelOrActivate() {
      if (this.newPowerPlantStatus === "canceled") {
        this.cancelPowerPlant(this.powerPlantFormData.powerPlantId);
        this.dialog_modify_status_powerPlant = false;
      } else {
        this.activatePowerPlant(this.powerPlantFormData.powerPlantId);
        this.dialog_modify_status_powerPlant = false;
      }
    },

    cancelPowerPlant(id) {
      const data = {
        updated_at: new Date(),
        status: "canceled",
      };
      updatePlantsFb(id, data);
    },

    activatePowerPlant(id) {
      const data = {
        updated_at: new Date(),
        status: "activated",
      };
      updatePlantsFb(id, data);
    },

    openPowerPlantForm(type, powerPlantId) {
      this.powerPlantFormData = {
        key: this.powerPlantFormData.key + 1,
        type,
        powerPlantId,
      };
      this.setPowerPlantDialog(true);
    },

    openPowerPlantContractsList(powerPlantId) {
      this.powerPlantContractData = {
        key: this.powerPlantContractData.key + 1,
        powerPlantId,
      };
      this.setPowerPlantContractsList(true);
    },
  },

  mounted() {
    this.getPlants();
  },
};
</script>
